var map = {
	"./bot.store.js": "./src/store/modules/bot.store.js",
	"./dateTime.store.js": "./src/store/modules/dateTime.store.js",
	"./dydu.store.js": "./src/store/modules/dydu.store.js",
	"./editor.store.js": "./src/store/modules/editor.store.js",
	"./errors.store.js": "./src/store/modules/errors.store.js",
	"./history.store.js": "./src/store/modules/history.store.js",
	"./liveChat.store.js": "./src/store/modules/liveChat.store.js",
	"./messages.store.js": "./src/store/modules/messages.store.js",
	"./preQualification.store.js": "./src/store/modules/preQualification.store.js",
	"./queuing.store.js": "./src/store/modules/queuing.store.js",
	"./sidebar.store.js": "./src/store/modules/sidebar.store.js",
	"./timeSync.store.js": "./src/store/modules/timeSync.store.js",
	"./widget.store.js": "./src/store/modules/widget.store.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync \\.store\\.js$";